module.exports = __webpack_public_path__ + "static/media/icon-comments-green.7ad89855.svg";